import { createContext, useContext } from 'react';
import type {
    BrandMode,
    BrandThemeConfig,
    ResolvedTheme,
} from './theme.interface';

export type ThemeContextValue = {
	theme: ResolvedTheme;
	setBrandTheme: (theme: BrandThemeConfig | undefined) => void;
	setMode: (mode: BrandMode) => void;
};

export const ThemeContext = createContext<ThemeContextValue | undefined>(
    undefined,
);

export const useTheme = (): ThemeContextValue => {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
};
